const RETURN_TO_KEY = 'psyforge_auth_return_to';
const RETURN_TO_TTL_MS = 60 * 60 * 1000;

export function safeReturnTo(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname === '/auth') return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function rememberReturnTo(value: string): void {
  const path = safeReturnTo(value);
  if (!path) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    // Storage can be unavailable in private browsing; the URL parameter remains.
  }
}

export function consumeReturnTo(fallbackValue?: string | null): string | null {
  const fallback = safeReturnTo(fallbackValue);
  try {
    const raw = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as { path?: string; at?: number };
    if (!parsed.at || Date.now() - parsed.at > RETURN_TO_TTL_MS) return fallback;
    return safeReturnTo(parsed.path) ?? fallback;
  } catch {
    return fallback;
  }
}

export function authPathFor(returnTo: string): string {
  const safe = safeReturnTo(returnTo);
  return safe ? `/auth?returnTo=${encodeURIComponent(safe)}` : '/auth';
}